import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"
import FilterModal from "./ui/FilterModal"
import filter from "./asset/filter.svg"
import defaultImg from "./asset/default.jpg"
import entryIcon from "./asset/entry.svg"

import Pagenation from "widget/Pagenation"

import useGetEventList from "entity/event/useGetEventList"

import { convertEventStateAsName } from "shared/constant/lookup/eventState"
import { convertEventTypeAsName } from "shared/constant/lookup/eventType"
import timestampCalculator from "shared/lib/timestampCalculator"

const EventList = () => {
    const navigate = useNavigate()

    const [isFilterShow, setIsFilterShow] = useState(false)

    const [eventDataList] = useGetEventList()

    return (
        <>
            {isFilterShow && <FilterModal closeEvent={() => setIsFilterShow(state => !state)} />}

            <Style.Wrapper>

                <Style.TitleDiv>
                    <h2>대회 목록</h2>
                    <button onClick={() => setIsFilterShow(true)}>
                        <p>필터링</p>
                        <img src={filter} />
                    </button>
                </Style.TitleDiv>

                <Style.EventList>
                    {eventDataList?.data?.event_list?.map(elem =>
                        <Style.EventElement onClick={() => navigate(`/event/${elem?.idx}/detail`)}>
                            <img src={elem?.img_list?.length > 0 ? elem?.img_list[0] : defaultImg} />
                            <Style.ShadowDiv />
                            <Style.EventTitleDiv $type={elem?.event_state_flag}>
                                <h1>{elem?.name}</h1>
                                <p>{timestampCalculator(elem?.date)}</p>
                                <h2>{convertEventStateAsName[elem?.event_state_flag]}</h2>
                            </Style.EventTitleDiv>
                            <Style.EventControlDiv $type={elem?.event_type_flag}>
                                <p>{convertEventTypeAsName[elem?.event_type_flag]}</p>
                                <h2><img src={entryIcon} />{elem?.max_entry ? `${elem?.ticket_count} / ${elem?.max_entry}` : "제한 없음"}</h2>
                            </Style.EventControlDiv>
                        </Style.EventElement>
                    )}
                    {eventDataList?.data?.event_list?.length < 1 && <Style.Option>아직 대회가 생성되지 않았습니다.</Style.Option>}
                </Style.EventList>

                <Pagenation maxPage={eventDataList?.data?.max_page} />

            </Style.Wrapper >
        </>
    )
}

export default EventList